import styled from '@emotion/styled';

const EditorWrapper = styled('article')(({ theme }) => ({
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: 4,
}));

export default EditorWrapper;
